<app-home-analytics
  *ngIf="activeLocation === 'SubAndPayment'"
></app-home-analytics>
<app-home-analytics-profile
  *ngIf="activeLocation === 'Profile'"
></app-home-analytics-profile>
<app-home-analytics-sub-and-payment
  *ngIf="activeLocation === 'Root'"
></app-home-analytics-sub-and-payment>
